import React, { useEffect } from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";
import CardOverflow from "@mui/joy/CardOverflow";
import CardContent from "@mui/joy/CardContent";
import AspectRatio from "@mui/joy/AspectRatio";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Chip from "@mui/joy/Chip";
import Button from "@mui/joy/Button";
import HandshakeIcon from "@mui/icons-material/Handshake";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/joy/Divider";
import IconButton from "@mui/joy/IconButton";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MenuAdmin from "./menuadmin";

export default function RevisarAventuras() {
  let [aventuras, setAventuras] = React.useState();
  let [posicion, setPosicion] = React.useState(0);
  let navigate = useNavigate();

  useEffect(() => {
    let getAventuras = async () => {
      try {
        let token = localStorage.getItem("token");
        let aventuras = await axios.get(
          `${process.env.REACT_APP_FRONTEND_URL}/api/aventura/revisar`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAventuras(aventuras.data);
      } catch (err) {
        if (err.response?.status === 403) {
          navigate("/");
        }
        console.log(err);
        console.log("Error al obtener Aventuras");
      }
    };

    getAventuras();
  }, []);

  async function aprobarAventura() {
    try {
      let token = localStorage.getItem("token");

      let aprobar = await axios.post(
        `${process.env.REACT_APP_FRONTEND_URL}/api/aventura/aprobar`,
        aventuras[posicion],
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(aprobar);
    } catch (err) {
      console.log("No se pudo aprobar la aventura: " + err);
    }
  }

  async function rechazarAventura() {
    try {
      let token = localStorage.getItem("token");

      let rechazar = await axios.post(
        `${process.env.REACT_APP_FRONTEND_URL}/api/aventura/rechazar`,
        aventuras[posicion],
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(rechazar);
    } catch (err) {
      console.log("Tenemos un error al rechazar la Aventura: " + err);
    }
  }

  let Body = () => {
    return (
      <Box
        marginLeft={{ md: 40 }}
        marginRight={{ md: 40 }}
        marginTop={{ md: 0 }}
        marginBottom={{ md: 10 }}
      >
        <Tarjeta
          imagen={aventuras[posicion].imagen}
          titulo={aventuras[posicion].titulo}
          nivel={aventuras[posicion].nivel}
          categoria={aventuras[posicion].categoria}
          fecha={aventuras[posicion].fecha}
          descripcion={aventuras[posicion].descripcion}
          ubicacion={aventuras[posicion].ubicacion}
          latitud={aventuras[posicion].latitud}
          longitud={aventuras[posicion].latitud}
        />
      </Box>
    );
  };

  let Tarjeta = ({
    imagen,
    titulo,
    nivel,
    categoria,
    fecha,
    descripcion,
    ubicacion,
    latitud,
    longitud,
  }) => {
    return (
      <Box padding={20}>
        <Card variant="soft">
          <CardOverflow>
            <AspectRatio ratio={1.8}>
              <img
                src={`https://amigoutdoors.nyc3.digitaloceanspaces.com/uploads/${imagen}`}
                alt=""
                loading="lazy"
              />
            </AspectRatio>
          </CardOverflow>
          <CardContent sx={{ gap: 1 }}>
            <Typography level="title-lg">{titulo}</Typography>
            <Box display={"flex"} sx={{ gap: 1 }}>
              <Chip color="warning" size="sm">
                Nivel {nivel}
              </Chip>
              <Chip color="warning" size="sm">
                Categoría {categoria}
              </Chip>
              <Chip color="warning" size="sm">
                {fecha}
              </Chip>
            </Box>
            <Typography level="body-sm">{descripcion}</Typography>
            <Box
              display="flex"
              sx={{ gap: 0.5 }}
              alignContent={"center"}
              alignItems={"center"}
            >
              <LocationOnIcon />
              <Typography level="body-xs">Punto de Encuentro</Typography>
            </Box>
            <Box
              display="flex"
              sx={{ gap: 1 }}
              alignContent={"center"}
              alignItems={"center"}
            >
              <Typography level="body-sm" fontWeight={600}>
                {ubicacion}
              </Typography>
              <Button
                color="neutral"
                size="sm"
                variant="outlined"
                onClick={() => {
                  window.open(
                    `https://www.google.com/maps?q=${longitud},${latitud}`,
                    "_blank"
                  );
                }}
              >
                Ver en Google Maps
              </Button>
            </Box>
          </CardContent>
          <Box marginTop={2} marginBottom={2}>
            <Divider />
          </Box>
          <Box display={"flex"} justifyContent="space-between">
            <IconButton sx={{ "&:hover": { backgroundColor: "transparent" } }}>
              <CloseIcon
                sx={{ fontSize: 40 }}
                onClick={() => {
                  console.log("hola");
                  rechazarAventura();
                  setPosicion(posicion + 1);
                }}
              />
            </IconButton>
            <IconButton sx={{ "&:hover": { backgroundColor: "transparent" } }}>
              <HandshakeIcon
                sx={{ fontSize: 40 }}
                onClick={() => {
                  console.log("hola");
                  aprobarAventura();
                  setPosicion(posicion + 1);
                }}
              />
            </IconButton>
          </Box>
        </Card>
      </Box>
    );
  };

  function NoHayMasAventurasAModerar() {
    return (
      <Box
        sx={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          alignContent: "center",
          height: "100vh",
        }}
      >
        <Typography level="body-sm">No hay más Aventuras a Moderar</Typography>
      </Box>
    );
  }

  function finaldeModeracion() {
    if (posicion === aventuras.length) {
      return <NoHayMasAventurasAModerar />;
    } else {
      return <Body />;
    }
  }

  return (
    <Box flex={1}>
      {aventuras ? finaldeModeracion() : null} <MenuAdmin />
    </Box>
  );
}
